import styles from '../UnifyOnboarding.module.scss';

export const StepNumber = ({ number, isActive, isCompleted }) => (
	<div
		className={`${styles.stepNumber} ${isCompleted ? styles.completed : ''} ${isActive ? styles.active : ''}`}
		data-cy={`step-${number}-${isCompleted ? 'completed' : isActive ? 'active' : 'pending'}`}
	>
		{number}
	</div>
);
